export default __webpack_public_path__ + "static/media/D_003.c2ed88b1.jpg";